const SESSION_DEBUG_KEY = '__horrolSessionDebug';
const MAX_DEBUG_ENTRIES = 400;

const getDebugStore = () => {
	if (typeof window === 'undefined') {
		return [];
	}

	if (!Array.isArray(window[SESSION_DEBUG_KEY])) {
		window[SESSION_DEBUG_KEY] = [];
	}

	return window[SESSION_DEBUG_KEY];
};

export const debugSession = (scope, event, payload = {}) => {
	const entry = {
		at: new Date().toISOString(),
		scope,
		event,
		payload,
	};

	try {
		const store = getDebugStore();
		store.push(entry);
		if (store.length > MAX_DEBUG_ENTRIES) {
			store.splice(0, store.length - MAX_DEBUG_ENTRIES);
		}
	} catch (error) {
		console.warn('[SessionDebug] persist failed', error);
	}

	if (
		typeof window !== 'undefined' &&
		(window.location.hostname === 'localhost' ||
			window.localStorage.getItem('horrol:debugSessionConsole') === 'true')
	) {
		console.info('[SessionDebug]', scope, event, payload);
	}
	return entry;
};

export const getSessionDebugEntries = () => {
	try {
		return [...getDebugStore()];
	} catch (error) {
		return [];
	}
};

export const getJwtSummary = (jwtToken) => {
	if (!jwtToken || typeof jwtToken !== 'string') {
		return null;
	}

	try {
		const [, payload] = jwtToken.split('.');
		if (!payload) {
			return null;
		}

		const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
		const json = JSON.parse(atob(normalized));

		return {
			sub: json.sub,
			exp: json.exp,
			iat: json.iat,
			tokenUse: json.token_use,
		};
	} catch (error) {
		return {
			parseError: true,
		};
	}
};
